import React, { useEffect, useState } from "react";
import "../screenstyles/Product.css";
import {
  getAlwaseetMerchantInvoices,
  AlwaseetInvoice,
} from "../services/alwaseetService";

const formatCurrency = (value: string | number | undefined) => {
  const amount = Number(value || 0);
  return `${amount.toLocaleString("en-US")} دينار`;
};

export default function AlwaseetInvoices() {
  const [invoices, setInvoices] = useState<AlwaseetInvoice[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const data = await getAlwaseetMerchantInvoices();
      setInvoices(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error loading Alwaseet invoices:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  return (
    <div className="product-container">
      <div className="max-w-full flex items-center justify-between bg-[#262d34] text-white px-6 py-3 rounded-t-lg shadow-md">
        <h1
          className="text-xl flex-1"
          style={{ fontFamily: "Tajawal, sans-serif" }}
        >
          فــــواتــــيــــر الــــوســــيــــط
        </h1>
      </div>

      {loading ? (
        <p>جاري تحميل البيانات...</p>
      ) : (
        <div className="table-container">
          <table className="product-table">
            <thead className="color-table">
              <tr>
                <th>#</th>
                <th>رقم الفاتورة</th>
                <th>قيمة الفاتورة</th>
                <th>عدد الطلبات المسلمة</th>
                <th>عدد طلبات الاستبدال</th>
                <th>الحالة</th>
                <th>آخر تحديث</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((invoice, index) => (
                <tr key={`${invoice.id}-${index}`}>
                  <td>{index + 1}</td>
                  <td>{invoice.id}</td>
                  <td>{formatCurrency(invoice.merchant_price)}</td>
                  <td>{invoice.delivered_orders_count}</td>
                  <td>{invoice.replacement_delivered_orders_count}</td>
                  <td>{invoice.status}</td>
                  <td>{invoice.updated_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}